import { FieldError } from "client/lib/apt-merchant";

import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";
import { isNumber, maxLength, minLength } from "../../validate";

export class AbnField extends Field<string> {
  constructor(model: Merchant, opts: Partial<MerchantField<string>> = {}) {
    super(model, {
      dataType: "string",
      propertyName: "abn",
      uiFieldType: "Input",
      uiInputBaseProps: {
        inputMode: "numeric",
      },
      ...opts,
    });
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    if (registeredCountry === "Australia") {
      return true;
    }
    return false;
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }

  get testValue(): string {
    // url for ABN's
    // https://data.gov.au/dataset/ds-dga-5bd7fcab-e315-42cb-8daf-50b7efc2027e/details
    const businessType = this._model.companyInformation.businessType.value;
    switch (businessType) {
      case "Private Company":
        return "53004085616";
      case "Sole Trader":
        return "11001093368";
      default:
        return "14733490889";
    }
  }

  _validate(): void {
    if (typeof this.value === "undefined") return;

    if (!minLength(9)(this.value)) {
      throw new FieldError(this, "Min length 9", "InvalidLength");
    }
    if (!maxLength(11)(this.value)) {
      throw new FieldError(this, "Max length 11", "InvalidLength");
    }

    if (!isNumber(this.value)) {
      throw new FieldError(
        this,
        "No dashes/other characters accepted",
        "InvalidCompanyNumber"
      );
    }
  }
}
